/* eslint-disable @heidi/rules/no-new-legacy-coding-files -- noun collision, not coding
   domain code: these are analytics emit hosts lifted verbatim out of
   `analyticsScribeModel`, and their event names are what carries the
   `Coding`/`ClinicalCod` noun. An emit host cannot live in `packages/coding`,
   whose `/data` and `/contracts` zones are headless and may not import an
   app tracker — the package owns the event DESCRIPTOR, the app owns the emit.
   Relocating this file to a hub with no coding noun would be the dodge the
   rule exists to catch, so it stays beside its 56 sibling emit modules. */
/**
 * Emit hosts for the `clinical-codes` analytics group — 2 functions
 * lifted out of `analyticsScribeModel`'s effects so a call site can emit
 * without holding a Rematch `dispatch`. Every payload is the effect's own.
 */
import { track } from '@/lib/analytics/track';
import { trackLegacyEvent } from '@/lib/analytics/track-legacy-event';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import { SegmentActionName, SegmentObjectName } from '@/models/analytics/segment-names';
import { type CodeSystem } from '@heidi/coding/contracts';
import { type CodedClinicalEntityRelevance } from '@heidi/schema/ml-scribe';

export function trackClinicalCodeCopied(input: {
  sessionId: string;
  noteId: string;
  kindeUserId: string;
  code: string;
  codeSystem: CodeSystem;
  relevance: CodedClinicalEntityRelevance;
  relevanceScore: number;
}) {
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.ClinicalCodeCopied,
    props: {
      session_id: input.sessionId,
      note_id: input.noteId,
      kinde_user_id: input.kindeUserId,
      code: input.code,
      code_system: input.codeSystem,
      relevance: input.relevance,
      relevance_score: input.relevanceScore,
    },
  });
}

export function trackCodingSidebarOpened(input: {
  sessionId: string;
  noteId: string;
  kindeUserId: string;
  codesetsEnabled: string[];
  totalCodesAvailable: number;
}) {
  const { sessionId, noteId, kindeUserId, codesetsEnabled, totalCodesAvailable } = input;
  trackLegacyEvent({
    name: SegmentObjectName.Session,
    props: {
      action: SegmentActionName.CodingSidebarOpened,
      sessionId,
      noteId,
      kindeUserId,
      codesetsEnabled,
      totalCodesAvailable,
    },
  });
}
